<template>
  <BaseForm
    :key="driverId || 'new'"
    :title="formTitle"
    :formData="driverData"
    :fields="fields"
    :submitUrl="submitUrl"
    :method="method"
    @form-success="handleSuccess"
    @form-error="handleError"
  />
</template>

<script>
import BaseForm from './BaseForm.vue';
import axios from 'axios';

export default {
  components: {
    BaseForm
  },
  props: {
    driverId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      driverData: {
        name: '',
        hauler_id: ''
      },
      fields: [
        { model: 'name', label: 'Name', required: true, type: 'text' },
        { model: 'hauler_id', label: 'Hauler', required: true, type: 'select', optionsUrl: '/api/v1/hauler/haulers/', labelField: 'name' }
      ]
    };
  },
  computed: {
    formTitle() {
      return this.driverId ? `Edit Driver` : 'Add Driver';
    },
    submitUrl() {
      return this.driverId ? `/api/v1/driver/drivers/${this.driverId}/` : '/api/v1/driver/drivers/';
    },
    method() {
      return this.driverId ? 'put' : 'post';
    }
  },
  mounted() {
    if (this.driverId) {
      this.loadDriverData();
    }
  },
  methods: {
    loadDriverData() {
      axios.get(`/api/v1/driver/drivers/${this.driverId}/`).then(response => {
        this.driverData = response.data;
        console.log(this.driverData);
      }).catch(console.error);
    },
    handleSuccess() {
      this.$q.notify({
        color: 'green',
        position: 'top',
        message: 'Driver information saved successfully!',
        icon: 'check_circle',
        timeout: 3000
      });
    },
    handleError(error) {
      console.error(error);
      this.$q.notify({
        color: 'red',
        position: 'top',
        message: 'There was a problem saving the driver information!',
        icon: 'check_circle',
        timeout: 3000
      });
    }
  }
};
</script>
